import { render, staticRenderFns } from "./DetailPrice.vue?vue&type=template&id=1dfa5620&scoped=true"
import script from "./DetailPrice.vue?vue&type=script&lang=js"
export * from "./DetailPrice.vue?vue&type=script&lang=js"
import style0 from "./DetailPrice.vue?vue&type=style&index=0&id=1dfa5620&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1dfa5620",
  null
  
)

export default component.exports